// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"7a4aaa3d","239":"ad40150f","389":"82ec4bb0","445":"b50f2f2b","455":"22d4e1b1","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};